/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2017, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

export const Grid = ({ items, columns, evenlySpaceOutColumns, itemSpacing, className, itemClassName, rowClassName }) => {
  // restructure props.items into array of row arrays according to number of columns
  let gridItems = items.length === 0
    ? []
    : items.map((i, index) => {
        if (index === 0) {
          return items.slice(index, columns)
        }
        // if index is multiple of columns, create sub-array as new grid row
        if (index % columns === 0) {
          return items.slice(index, index + columns)
        }

        return null
      }).filter(item => item)  // filter out 'null' rows from original array

  // check if last array element needs filling to complete matrix/grid
  let lastElement = items.length === 0 ? null : gridItems[gridItems.length - 1]
  let itemsNeededToCompleteRow = items.length === 0 ? 0 : lastElement.length % columns
  if (itemsNeededToCompleteRow > 0) {
    let nullElementsToAdd = columns - itemsNeededToCompleteRow
    // create array with number of null elements to add
    let tail = Array(nullElementsToAdd).fill(null)
    // add null elements to last array element
    lastElement.splice(itemsNeededToCompleteRow, 0, ...tail)
  }

  return (
    <div className={className}>
      {gridItems.map((rowItem, rowIndex) => (
        <div className={`slds-grid ${evenlySpaceOutColumns ? 'slds-grid_align-space' : ''} ${rowClassName}`} key={`grid_rowitem_${rowIndex}`}>
          {rowItem.map((item, index) => (
            <div
              className={`slds-col slds-size_1-of-${columns} ${itemSpacing && index < columns ? `slds-m-right_${itemSpacing }` : ''} ${itemClassName}`}
              key={`grid_item_${index}`}>
              {item}
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}

Grid.defaultProps = {
  columns: 2,
  rowClassName: '',
  itemClassName: ''
}

Grid.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  columns: PropTypes.number.isRequired,
  evenlySpaceOutColumns: PropTypes.bool,
  itemSpacing: PropTypes.oneOf([
    'xxx-small', 'xx-small', 'x-small', 'small',
    'medium',
    'large', 'x-large', 'xx-large'
  ]),
  className: PropTypes.string,
  rowClassName: PropTypes.string,
  itemClassName: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/grid/index.js